// extracted by mini-css-extract-plugin
export default {"workload_modal":"WorkloadModal_workload_modal__nbobJ","workload_modal_header":"WorkloadModal_workload_modal_header__nDiGC"};